import { API_ENDPOINTS } from '@/utils/constants/end-points';
import {
  setTenantDateFormat,
  TenantDateFormat,
} from '@/utils/tenant-date-utils';

import apiClient from '../api-client';

interface TenantSettingsResponse<T> {
  success: boolean;
  data: T;
  message: string;
}

/** The tenant's date / time format (.NET patterns) and time zone. */
export const getTenantDateFormat = async (): Promise<TenantDateFormat> => {
  const response = await apiClient.get<
    TenantSettingsResponse<TenantDateFormat>
  >(`${API_ENDPOINTS.TENANTSETTINGS}/date-format`);
  return response.data.data;
};

/**
 * Loads the tenant's date format and activates it for pickers and any ISO
 * values formatted on screen. A failure keeps the Singapore default rather
 * than blocking the app — the API formats its own responses either way.
 */
export const loadTenantDateFormat = async (): Promise<void> => {
  try {
    setTenantDateFormat(await getTenantDateFormat());
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('Tenant date format not loaded; using the default.', err);
  }
};
